import { useParams } from 'react-router';

import { FormikHelpers } from 'formik';
import { useSnackbar } from 'notistack';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useConfigPedidoStepContext } from 'pages/compra/configuracao-pedido/contexts';
import { ConfigPedidoPedidosSazonais } from 'pages/compra/configuracao-pedido/types';

export function useMutatePedidosSazonais() {
    const { setActiveStepSaved } = useConfigPedidoStepContext();
    const { mutate, isLoading } = useFormMutation();
    const { enqueueSnackbar } = useSnackbar();
    const { showError } = useShowError();
    const { id } = useParams();

    /**
     * Valida se os dados do formulário estão corretos.
     */
    const validateTipoLogisticaLoja = (formData: ConfigPedidoPedidosSazonais): boolean => {
        const primeiraLojaSemTipo = formData.lojasMetaAtingida.find((m) => !m.tipoLogisticaLoja);

        if (primeiraLojaSemTipo) {
            enqueueSnackbar(`Loja ${primeiraLojaSemTipo.loja.cdLoja} - ${primeiraLojaSemTipo.loja.dsNomeFantasia}: Tipo de logística é obrigatório`, {
                variant: 'error',
            });

            return false;
        }

        return true;
    };

    const onSubmit = (formData: ConfigPedidoPedidosSazonais, { resetForm }: FormikHelpers<ConfigPedidoPedidosSazonais>) => {
        if (!validateTipoLogisticaLoja(formData)) return;

        mutate(
            {
                url: `/gestao/lojametaatingida/configpedido/${id}/save`,
                formData,
                preventRedirect: true,
                preventSnack: true,
            },
            {
                onSuccess: ({ data }: any) => {
                    const { message, percentualNotaRoyaltiesSazonal, lojasMetaAtingida } = data;

                    resetForm({
                        values: {
                            lojasMetaAtingida,
                            percentualNotaRoyaltiesSazonal,
                        },
                    });

                    setActiveStepSaved();

                    enqueueSnackbar('Metas salvas com sucesso', { variant: 'success' });

                    if (message) {
                        enqueueSnackbar(message, { variant: 'warning' });
                    }
                },
                onError: (error: any) => showError(error, 'Erro ao salvar as metas'),
            },
        );
    };

    return { onSubmit, isLoading };
}
